import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=9a11464e&scoped=true&"
import script from "./Stage.vue?vue&type=script&lang=js&"
export * from "./Stage.vue?vue&type=script&lang=js&"
import style0 from "./Stage.vue?vue&type=style&index=0&id=9a11464e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a11464e",
  null
  
)

export default component.exports